/* eslint-disable */
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { HOST, PORT } from '../../environment';

/**
 * Resolves TOKA station ID from URL (e.g. /toka/61250) to 220 port numbers
 * and redirects to /startMany?ports=5013,5014.
 * Use this so that https://220-km.com/toka/61250 works like the TOKA app link.
 */
export default function TokaRedirectPage() {
  const { tokaId } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!tokaId || !/^\d+$/.test(tokaId)) {
      setError(t('qrScanner.invalidTokaUrl'));
      return;
    }
    let cancelled = false;
    fetch(`${HOST}:${PORT}/api/device/v2/ports-by-toka?toka_number=${encodeURIComponent(tokaId)}`)
      .then(res => res.json())
      .then(data => {
        if (cancelled) return;
        const portNumbers = data?.portNumbers || [];
        if (portNumbers.length > 0) {
          navigate(`/startMany?ports=${portNumbers.join(',')}`, { replace: true });
        } else {
          setError(t('qrScanner.tokaNotFound'));
        }
      })
      .catch(() => {
        if (!cancelled) setError(t('qrScanner.tokaLookupError'));
      });
    return () => {
      cancelled = true;
    };
  }, [tokaId, navigate, t]);

  if (error) {
    return (
      <div
        style={{
          padding: 24,
          textAlign: 'center',
          color: 'var(--color-text, #fff)',
        }}
      >
        <p style={{ marginBottom: 16 }}>{error}</p>
        <button
          type="button"
          onClick={() => navigate('/scanner')}
          style={{
            padding: '12px 24px',
            fontSize: '16px',
            borderRadius: 12,
            border: 'none',
            background: 'linear-gradient(-16deg, #C100B9 0%, #6e00d4 100%)',
            color: '#fff',
            cursor: 'pointer',
          }}
        >
          {t('qrScanner.nameButton')}
        </button>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 48,
        color: 'var(--color-text, #fff)',
      }}
    >
      {t('historyPage.loading')}
    </div>
  );
}
